import { memoize } from "lodash-es";

import { IWithRouteMatchProps, IWithRoutePropsProps } from "@/infrastructure/Route";

export interface ClientPageSearchParams {
  tab: string;
}

export interface ClientMatchParams {
  slug: string;
}

export interface ClientMatchProps extends IWithRouteMatchProps<ClientMatchParams> {}

export interface ClientRouteParams {
  slug: string;
}

export interface ClientRouteProps extends IWithRoutePropsProps<ClientRouteParams> {}

const transformPropsBody = (props: ClientMatchProps) => {
  return { slug: props.match.params.slug };
};

const transformPropsResolver = (props: ClientRouteProps) => {
  return props.location.pathname + props.location.search;
};

export const transformRouteProps = memoize(transformPropsBody, transformPropsResolver);
